export const environment = {
    production: true,
    statusUrl: 'https://api2.alsuper.com',
    rootUrl: 'https://staging.alsuperapi.com',
    rootServicesUrl: 'https://api2.alsuper.com/v1',
    trackingUrl: 'https://tracking.alsuper.com',
    siteUrl: 'https://cliente-web-staging.web.app',
    shopperUrl: 'https://shopper-center-staging.web.app',
    lambdaUrl: 'https://yyiz4vaag7.execute-api.us-west-2.amazonaws.com/staging',
    firebase: {
        apiKey: 'AIzaSyBbw1ydFIh8FdG-ttgPdEfWn1rOEKGNgYQ',
        authDomain: 'alsuper-prod.firebaseapp.com',
        projectId: 'alsuper-prod',
        storageBucket: 'alsuper-prod.appspot.com',
        messagingSenderId: '251054716727',
        appId: '1:251054716727:web:2b791ed75afa09b0684cb2',
        measurementId: 'G-HP8R8L49ST'
    },
    googleMaps: {
        apiKey: 'AIzaSyAnNGcvZNu8UswLje8iaVDxLMPn7ooCyEo'
    },
    paypalSrc: 'https://www.paypal.com/sdk/js?components=buttons,hosted-fields&client-id=AdX8AIECviP1ddNmxryfVyBfIGbvh00jvZShN7oLEDqUMyKFKWQR6ILHod-EXRZ9KpExhW9WiA9aMdT2&vault=true&intent=tokenize&locale=es_MX&currency=MXN',
    fncls: 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99',
    sVarRTAccount: 'AS_GYKWUGWKTHZ24_RT',
    sVarACDCCard: 'AS_GYKWUGWKTHZ24_PYMNT',
    googleAnalytics: {
        id: 'G-FHVSB6296K',
        url: 'https://www.googletagmanager.com/gtag/js?id='
    },
    profileWhatsapp: 'https://api.whatsapp.com/send?',
    facebookKey: '1046832069412227',
    googleClientID: '552566805419-lut8dd0v0qiouj0ubvqk6c51pbm973m5.apps.googleusercontent.com',
    appStore: 'https://apps.apple.com/mx/app/alsuperapp/id1445790957',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.exosfera.alsuper&hl=es_MX',
    version: 'v1.8.0',
    recaptcha: {
        siteKey: '6LcvQOYfAAAAAPQKn9nbJYS2MML-B_4ZCvQSr_En',
    },
    copomex: {
        url: 'https://api.copomex.com/query',
        token: 'pruebas'
    },
    images: 'https://d2e63rjlg57kwc.cloudfront.net',
    pinterestId: '2613797205828',
    defaultStore: '6',
    zendeskConfig: {
        url: 'https://static.zdassets.com/ekr/snippet.js',
        apiKey: 'e7c0a81c-b121-46ac-8c7f-d2f31ebb701a'
    },
    firebaseDocs: {
        order: 'ordersPrd'
    }
};
